/* eslint-disable no-console */
import { AxiosResponse } from 'axios';
import { isArray } from 'lodash-es';
import { HTML_DECODE_CONFIG } from '../helpers/const';
import { decodeHtml } from '@/shared/helpers';
import { applyTransformToArrayField, getValueByPath, matchesRoute, setValueByPath } from '../helpers/html-transform';

const showLogging = false;

/**
 * Axios response middleware that HTML-decodes configured fields
 * from API responses before they reach the application.
 *
 * - Applies only to routes defined in `HTML_DECODE_CONFIG`
 * - Decodes only specific fields
 * - Supports single objects, arrays of objects and nested array of objects`
 *
 */
export const decodeHtmlMiddleware = (response: AxiosResponse): AxiosResponse => {
  const { method = '', url = '' } = response.config;
  const config = HTML_DECODE_CONFIG.find((c) => c.methods.includes(method.toUpperCase()) && matchesRoute(c.path, url));

  if (!config?.fields) return response;

  const data = response.data?.data;
  const responseData = isArray(data) ? data : [data];

  responseData.forEach((item) => {
    config.fields.forEach((field) => {
      if (field.includes('[]')) {
        const didTransform = applyTransformToArrayField(item, field, decodeHtml);

        if (showLogging && !didTransform) {
          console.warn(`[HTML Decode Middleware] Field "${field}" found but is not a valid array`);
        }

        if (showLogging && didTransform) {
          console.log(`[HTML Decode Middleware] Field "${field}" was decoded`);
        }

        return;
      }

      const value = getValueByPath(item, field);

      if (typeof value !== 'string') {
        if (showLogging) {
          console.warn(`[HTML Decode Middleware] Skipped field "${field}" — value is not a string`);
        }
        return;
      }

      const decodedValue = decodeHtml(value);
      setValueByPath(item, field, decodedValue);

      if (showLogging) {
        console.groupCollapsed(`[HTML Decode Middleware] ${field}`);
        console.log('Before:', value);
        console.log('After:', decodedValue);
        console.groupEnd();
      }
    });
  });

  return response;
};
